export default [
  {
    path: '/knowledge/index',
    name: 'knowledge_index',
    component: () => import('@/views/knowledge/index'),
    meta: { title: "知识产权服务子平台", requireLogin: false },
    redirect: '/knowledge/index',
    children: [
      {
        path: '/knowledge/index',
        name: 'knowledge_index',
        component: () => import('@/views/knowledge/components/index'),
        meta: { title: "科技金融服务子平台", requireLogin: false },
      },
      {
        path: '/knowledge/investor',
        name: 'knowledge_investor',
        component: () => import('@/views/knowledge/components/conts/investor'),
        meta: { title: "知识产权交易", requireLogin: false },
        redirect: '/knowledge/investor/index',
        children: [
          {
            path: '/knowledge/investor/index',
            name: 'knowledge_investor_index',
            component: () => import('@/views/knowledge/components/conts/investorcont/index'),
            meta: { title: "知识产权交易", requireLogin: false },
          },
          {
            path: '/knowledge/investor/page',
            name: 'knowledge_investor_page',
            component: () => import('@/views/knowledge/components/conts/investorcont/page'),
            meta: { title: "知识产权交易详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/knowledge/investorCenter',
        name: 'knowledge_investorCenter',
        component: () => import('@/views/knowledge/components/conts/InvestorCenter'),
        meta: { title: "金融顾问", requireLogin: false },
        redirect: '/knowledge/investorCenter/index',
        children: [
          {
            path: '/knowledge/investorCenter/index',
            name: 'knowledge_investorCenter_index',
            component: () => import('@/views/knowledge/components/conts/investorCentercont/index'),
            meta: { title: "金融顾问", requireLogin: false },
          },
          {
            path: '/knowledge/investorCenter/page',
            name: 'knowledge_investorCenter_page',
            component: () => import('@/views/knowledge/components/conts/investorCentercont/page'),
            meta: { title: "金融顾问详情", requireLogin: false },
          }
        ]
      },
      
      {
        path: '/knowledge/need',
        name: 'knowledge_need',
        component: () => import('@/views/knowledge/components/conts/need'),
        meta: { title: "知识产权需求", requireLogin: false },
        redirect: '/knowledge/need/index',
        children: [
          {
            path: '/knowledge/need/index',
            name: 'knowledge_need_index',
            component: () => import('@/views/knowledge/components/conts/needcont/index'),
            meta: { title: "知识产权需求", requireLogin: false },
          },
          {
            path: '/knowledge/need/page',
            name: 'knowledge_need_page',
            component: () => import('@/views/knowledge/components/conts/needcont/page'),
            meta: { title: "知识产权需求详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/knowledge/invertorInstitution',
        name: 'knowledge_invertorInstitution',
        component: () => import('@/views/knowledge/components/conts/invertorInstitution'),
        meta: { title: "知识产权机构", requireLogin: false },
        redirect: '/knowledge/institution/index',
        children: [
          {
            path: '/knowledge/institution/index',
            name: 'knowledge_institution_index',
            component: () => import('@/views/knowledge/components/conts/institutioncont/index'),
            meta: { title: "知识产权机构", requireLogin: false },
          },
          {
            path: '/knowledge/institution/page',
            name: 'knowledge_institution_page',
            component: () => import('@/views/knowledge/components/conts/institutioncont/page'),
            meta: { title: "知识产权机构详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/knowledge/project',
        name: 'knowledge_project',
        component: () => import('@/views/knowledge/components/conts/project'),
        meta: { title: "创业项目", requireLogin: false },
        redirect: '/knowledge/project/index',
        children: [
          {
            path: '/knowledge/project/index',
            name: 'knowledge_project_index',
            component: () => import('@/views/knowledge/components/conts/projectcont/index'),
            meta: { title: "创业项目", requireLogin: false },
          },
          {
            path: '/knowledge/project/page',
            name: 'knowledge_project_page',
            component: () => import('@/views/knowledge/components/conts/projectcont/page'),
            meta: { title: "创业项目详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/knowledge/financialProduct',
        name: 'knowledge_financialProduct',
        component: () => import('@/views/knowledge/components/conts/financialProduct'),
        meta: { title: "金融产品", requireLogin: false },
        redirect: '/knowledge/product/index',
        children: [
          {
            path: '/knowledge/product/index',
            name: 'knowledge_product_index',
            component: () => import('@/views/knowledge/components/conts/productcont/index'),
            meta: { title: "金融产品", requireLogin: false },
          },
          {
            path: '/knowledge/product/page',
            name: 'knowledge_product_page',
            component: () => import('@/views/knowledge/components/conts/productcont/page'),
            meta: { title: "金融产品详情", requireLogin: false },
          }
        ]
      },
      {
        path: '/knowledge/zclooplist',
        name: 'knowledge_zclooplist',
        component: () => import('@/views/knowledge/components/conts/zcloop/index'),
        meta: { title: "知识产权转让列表", requireLogin: false }
      },
      {
        path: '/knowledge/zcloop',
        name: 'knowledge_zcloop',
        component: () => import('@/views/knowledge/components/conts/zcloop/page'),
        meta: { title: "知识产权转让详情", requireLogin: false }
      },
      {
        path: '/knowledge/video',
        name: 'knowledge_video',
        component: () => import('@/views/knowledge/components/conts/video'),
        meta: { title: "知识产权培训", requireLogin: false }
      },
      {
        path: '/knowledge/video/Detail',
        name: 'knowledge_video_Detail',
        component: () => import('@/views/knowledge/components/conts/consultationcont/videoDetail'),
        meta: { title: "知识产权培训", requireLogin: false },
      },
      {
        path: '/knowledge/activery',
        name: 'knowledge_activery',
        component: () => import('@/views/knowledge/components/conts/consultation1'),
        meta: { title: "项目路演", requireLogin: false }
      },
      {
        path: '/knowledge/activery/Detail',
        name: 'knowledge_activery_Detail',
        component: () => import('@/views/knowledge/components/conts/consultationcont/activeryDetail'),
        meta: { title: "项目路演", requireLogin: false },
      },
      {
        path: '/knowledge/law',
        name: 'knowledge_law',
        component: () => import('@/views/knowledge/components/conts/consultation'),
        meta: { title: "通知公告", requireLogin: false },
      },
      {
        path: '/knowledge/law/page',
        name: 'knowledge_law_page',
        component: () => import('@/views/knowledge/components/conts/consultationcont/noticeDetail'),
        meta: { title: "通知公告", requireLogin: false },
      },
      {
        path: '/knowledge/popularScience',
        name: 'knowledge_popularScience',
        component: () => import('@/views/knowledge/components/conts/popularScience'),
        meta: { title: "知识产权申报和科普", requireLogin: false },
      }
    ]
  },
]
